import React from 'react';
import { bool, shape, string } from 'prop-types';

const Subsoiling = ({
  className = '',
  notUseClass = false,
  style = {},
}) => (
  <svg className={notUseClass ? '' : className} style={style} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M19.9473 17.6182L17.3945 18.8945L16.5 17.1055L17.9473 16.3818V11H14.9473V17.6182L12.3945 18.8945L11.5 17.1055L12.9473 16.3818V11H9.94727V17.6182L7.39453 18.8945L6.5 17.1055L7.94727 16.3818V11H4.94727V17.6182L2.39453 18.8945L1.5 17.1055L2.94727 16.3818V9H19.9473V17.6182Z" fill="currentColor" />
    <path d="M21.9473 7H4.94727V5H21.9473V7Z" fill="currentColor" />
  </svg>
);

Subsoiling.propTypes = {
  className: string,
  notUseClass: bool,
  style: shape({}),
};

export default Subsoiling;
